import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { RootState } from '../state';
import { projectSettingsSchema } from '../schemas';
import EntityName from '../../enums/EntityName';
import { defaultProjectSettings } from './types';
import BookingProjectSettings from '../../types/model/BookingProjectSettings';

const getSelectedProjectId = (state: RootState) => state.bookings.selectedProjectId;

export const selectProjectSettings = createSelector(
  [
    (state: RootState) => state.bookingProjectSettings.byId,
    (state: RootState) => state.deliveryZone.byId,
    (state: RootState) => state.equipment.byId,
    getSelectedProjectId
  ],
  (projectSettings, deliveryZone, equipment, id) => {
    if (!id || !projectSettings[id]) {
      return {
        ...defaultProjectSettings,
        id
      };
    }

    const denormalisedSettings = denormalize(id, projectSettingsSchema, {
      [EntityName.BookingProjectSettings]: projectSettings,
      [EntityName.DeliveryZone]: deliveryZone,
      [EntityName.Equipment]: equipment
    }) as BookingProjectSettings;

    if (denormalisedSettings.bookingProjectSettings === null) {
      denormalisedSettings.bookingProjectSettings = defaultProjectSettings.bookingProjectSettings;
    }
    return denormalisedSettings;
  }
);
